// A score receipt belongs to the run that produced it, but its delayed board
// refresh belongs to the hosted session. Starting another run must therefore
// never cancel an accepted receipt's refresh. The queue also guards each timer
// callback so a misbehaving scheduler cannot issue the same read twice.
export class PortalRefreshQueue {
  constructor(setTimer = (callback, delayMs) => globalThis.setTimeout(callback, delayMs)) {
    this._setTimer = setTimer;
    this._pending = new Set();
  }

  schedule(delayMs, refresh) {
    let handle;
    handle = this._setTimer(() => {
      if (!this._pending.delete(handle)) return;
      refresh();
    }, delayMs);
    this._pending.add(handle);
    return handle;
  }

  get pendingCount() { return this._pending.size; }
}
